import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';

// Auto-detect GraphQL server URL based on current host
const getGraphQLHttpUrl = () => {
  if (import.meta.env.VITE_GRAPHQL_HTTP_URL) {
    return import.meta.env.VITE_GRAPHQL_HTTP_URL;
  }

  // Use current hostname to determine GraphQL URL
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  return `${protocol}//${hostname}:4000/graphql`;
};

const getGraphQLWsUrl = () => {
  if (import.meta.env.VITE_GRAPHQL_WS_URL) {
    return import.meta.env.VITE_GRAPHQL_WS_URL;
  }

  // Use current hostname to determine GraphQL WebSocket URL
  const hostname = window.location.hostname;
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProtocol}//${hostname}:4000/graphql`;
};

// HTTP connection to the API
const httpLink = new HttpLink({
  uri: getGraphQLHttpUrl(),
  credentials: 'include', // Include cookies for authentication
});

// WebSocket connection for subscriptions
const wsLink = new GraphQLWsLink(
  createClient({
    url: getGraphQLWsUrl(),
  })
);

// Split links based on operation type
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink
);

// Create Apollo Client
export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          getInvoices: {
            // Merge incoming data with existing data
            keyArgs: ['resolutionType', 'status'],
            merge(_existing = [], incoming) {
              return [...incoming];
            },
          },
          getDeletionLogs: {
            keyArgs: ['startDate', 'endDate'],
            merge(_existing = [], incoming) {
              return [...incoming];
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});
